import apiClient from './api-client';

const base = '/api/v1/notifications';

/**
 * Lists notifications for the current org. Returns a Spring Data Page
 * shape; each entry carries `read: boolean` for the current user.
 */
export function listNotifications({ page = 0, size = 20 } = {}) {
    return apiClient.get(base, { params: { page, size } });
}

export function getUnreadCount() {
    return apiClient.get(`${base}/unread-count`);
}

export function markRead(id) {
    return apiClient.post(`${base}/${id}/read`);
}

export function markAllRead() {
    return apiClient.post(`${base}/read-all`);
}
